import { OfferAcceptanceType } from '@/api/v2/requests/offers';
import { mdiDomain, mdiSitemap, mdiMapMarker } from '@mdi/js';
export const useAcceptanceColumns = (ctx, { offer, isReadOnlyAcceptance }) => {
    const acceptanceColumns = [
        {
            field: 'statuses',
            colId: 'centralStatus',
            sortable: false,
            headerName: '',
            headerComponent: 'IconHeader',
            headerClass: 'ag-header-cell--icon',
            headerComponentParams: {
                icon: mdiDomain,
                tooltipKey: 'offer-costs.approvalCentral',
            },
            width: 60,
            cellStyle: {
                padding: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            },
            cellRenderer: 'ObjectAcceptCell',
            cellRendererParams: (params) => {
                return {
                    level: OfferAcceptanceType.CENTRAL,
                    offerId: offer.id,
                    offerStatus: offer.status,
                    expiresAt: offer.expiresAt ?? null,
                    statuses: params?.data.statuses,
                    objectId: params?.data.id,
                    isReadOnlyAcceptance,
                };
            },
            pinned: 'right',
            suppressMovable: true,
        },
        {
            field: 'statuses',
            colId: 'structureStatus',
            sortable: false,
            headerName: '',
            headerComponent: 'IconHeader',
            headerClass: 'ag-header-cell--icon',
            headerComponentParams: {
                icon: mdiSitemap,
                tooltipKey: 'offer-costs.approvalStructure',
            },
            width: 60,
            cellStyle: {
                padding: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            },
            cellRenderer: 'ObjectAcceptCell',
            cellRendererParams: (params) => {
                return {
                    level: OfferAcceptanceType.STRUCTURE,
                    offerId: offer.id,
                    offerStatus: offer.status,
                    expiresAt: offer.expiresAt ?? null,
                    statuses: params?.data.statuses,
                    objectId: params?.data.id,
                    isReadOnlyAcceptance,
                };
            },
            pinned: 'right',
            suppressMovable: true,
        },
        {
            field: 'statuses',
            colId: 'placeStatus',
            sortable: false,
            headerName: '',
            headerComponent: 'IconHeader',
            headerClass: 'ag-header-cell--icon',
            headerComponentParams: {
                icon: mdiMapMarker,
                tooltipKey: 'offer-costs.approvalPlace',
            },
            width: 60,
            cellStyle: {
                padding: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            },
            cellRenderer: 'ObjectAcceptCell',
            cellRendererParams: (params) => {
                return {
                    level: OfferAcceptanceType.PLACE,
                    offerId: offer.id,
                    offerStatus: offer.status,
                    expiresAt: offer.expiresAt ?? null,
                    statuses: params?.data.statuses,
                    objectId: params?.data.id,
                    isReadOnlyAcceptance,
                };
            },
            pinned: 'right',
            suppressMovable: true,
        },
    ];
    return { acceptanceColumns };
};
